module.exports = __webpack_public_path__ + "static/media/37.582195fb.png";